import { _BaseSectionButtonData, ISectionButtonData, sectionButtonData } from "./_base-section-button"

export class SectionButtonSave 
    extends _BaseSectionButtonData
{
    protected constructor(buttonData?: ISectionButtonData){
        super(buttonData)

        this[sectionButtonData.disabled] = true;
        this[sectionButtonData.hide] = null;
}

    static create(buttonData?: ISectionButtonData) {
        return !!buttonData ? new SectionButtonSave(buttonData) : null;
    }
}
